import { useTranslation } from 'react-i18next';
import { Button } from '../base';
import type { ContextGroup } from '../../api/services';

interface GroupMenuModalProps {
  isOpen: boolean;
  group: ContextGroup | null;
  onClose: () => void;
  onDelete: (group: ContextGroup) => void;
  isDeleting?: boolean;
}

export const GroupMenuModal = ({ isOpen, group, onClose, onDelete, isDeleting }: GroupMenuModalProps) => {
  const { t } = useTranslation();

  if (!isOpen || !group) return null;

  const handleDelete = () => {
    if (window.confirm(t('groups.deleteConfirm', 'Delete this group? Links will not be deleted.'))) {
      onDelete(group);
      onClose();
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'var(--color-bg-secondary)',
          borderRadius: 'var(--radius-lg)',
          padding: 'var(--space-xl)',
          maxWidth: 320,
          width: '90%',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ marginBottom: 'var(--space-md)', color: 'var(--color-text-primary)' }}>{group.name}</h3>
        <div style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
          <Button variant="ghost" onClick={onClose}>
            {t('common.cancel', 'Cancel')}
          </Button>
          <Button variant="ghost" onClick={handleDelete} disabled={isDeleting} style={{ color: 'var(--color-error)' }}>
            {isDeleting ? 'Deleting...' : t('groups.delete', 'Delete group')}
          </Button>
        </div>
      </div>
    </div>
  );
};
